import { HTMLAttributes, useEffect, useState } from 'react';
import clsx from 'clsx';

type QuoteCreationMethodStatusViewProps = HTMLAttributes<HTMLDivElement> & {
  status?: string;
  size?: 'small' | 'medium' | 'large';
};

const QuoteCreationMethodStatusView = (props: QuoteCreationMethodStatusViewProps) => {
  const { className, status, size = 'medium' } = props;
  const [containerStyle, setContainerStyle] = useState({});
  const [showText, setShowText] = useState('');

  /**
   * effects
   */
  useEffect(() => {
    evaluateTextInfo();
  }, [status]);

  /**
   * methods
   */
  const evaluateTextInfo = () => {
    let textColor = '';
    let showText = '';
    let backgroundColor = 'transparent';
    if (!textColor) {
      switch (status) {
        case 'active':
        case 'system_generated':
        case 'system_switch_to_jove':
          showText = 'System';
          textColor = '#0E35D1';
          backgroundColor = '#EAF0FF';
          break;
        default:
          showText = 'Manually';
          textColor = '#1CB258';
          backgroundColor = '#E8F9EE';
          break;
      }
    }

    setShowText(showText);
    setContainerStyle({
      borderColor: `${textColor}`,
      color: `${textColor}`,
      backgroundColor,
    });
  };

  const getContainerSize = () => {
    if (size === 'small') {
      return 'rounded-full px-2 py-1 text-xs font-medium';
    } else if (size === 'medium') {
      return 'rounded-full px-2 py-1 text-[13px] font-medium';
    } else {
      return 'rounded-full px-2 py-1 text-sm font-bold';
    }
  };

  return (
    <div style={containerStyle} className={clsx('flex flex-row border', className, getContainerSize())}>
      {showText}
    </div>
  );
};

export default QuoteCreationMethodStatusView;
